import { addDoc, collection } from "firebase/firestore"
import { firebaseDB } from "~/services/firebase"

export const firebaseLog = async ({ message, user, type, error, json }) => {
    try {
        await addDoc(collection(firebaseDB, "mais_vendas_errors"), {
            message,
            type: type || "Desconhecido",
            user: user || "Desconecido",
            json: json ? JSON.stringify(json) : null,
            error: error || "Desconecido",
            timestamp: new Date().getTime(),
            date: new Date().toISOString(),
        });
    } catch (e) {
        console.error("Erro ao salvar log no Firebase", e);
    }
}
